import { useSelector } from "react-redux";
import { Imgs } from "../../img/Imgs/Imgs";
import { selectedLanguage } from "../../store/slices/selectedLanguageSlice";
import translations from "../../language.json";

const Journey = () => {
  const selectedLanguages = useSelector(selectedLanguage);

  return (
    <section className="journey">
      <div className="journey__container container">
        <img src={Imgs.journeyimg} alt="journey" />
        <div className="journey__context">
          <h2>{translations[selectedLanguages].journey.title}</h2>
          <p>{translations[selectedLanguages].journey.context}</p>
        </div>
      </div>
    </section>
  );
};

export default Journey;
